// extracted by mini-css-extract-plugin
export default {"VisuallyHidden":"VisuallyHidden-module--VisuallyHidden--oooNF"};